import { msg } from "../../locales/translate";
import type { IPaymentSession } from "../../types/types";

export type StatementTransaction = IPaymentSession & { kind?: string };
export const STATEMENT_TRANSACTIONS_PAGE_SIZE = 20;

export const getStatementTransactionsRequest = (statementId: number, page: number, perPage = STATEMENT_TRANSACTIONS_PAGE_SIZE) => ({
	method: "statements/daily/trx/get",
	data: { statement_id: statementId, page, per_page: perPage },
});

export const getStatementTransactionKind = (row: Pick<StatementTransaction, "kind" | "_is_release">) => {
	if (row.kind === "release" || (!row.kind && row._is_release)) return { label: msg("rollingReserveRelease"), release: true };
	if (row.kind === "txn" || row.kind === "transaction") return { label: msg("transaction"), release: false };
	return { label: row.kind || "—", release: false };
};

type RecordData = Record<string, unknown>;
const isRecord = (value: unknown): value is RecordData => !!value && typeof value === "object" && !Array.isArray(value);
const nonnegativeInteger = (value: unknown) => typeof value === "number" && Number.isInteger(value) && value >= 0;

export const parseStatementTransactions = (data: unknown) => {
	const rows = Array.isArray(data) ? data : isRecord(data) ? data.rows ?? data.items : undefined;
	if (!Array.isArray(rows) || rows.some(row => !isRecord(row) || typeof row.id !== "number")) {
		throw new Error(msg("unexpectedStatementTransactionsResponse"));
	}
	const pageData = isRecord(data) ? data.pages ?? data.pagination : null;
	if (pageData !== undefined && pageData !== null && !isRecord(pageData)) {
		throw new Error(msg("unexpectedStatementTransactionsPagination"));
	}
	const pagination = isRecord(pageData) ? pageData : null;
	if (pagination && (!nonnegativeInteger(pagination.total) || !nonnegativeInteger(pagination.page) || !nonnegativeInteger(pagination.perPage) || Number(pagination.perPage) < 1)) {
		throw new Error(msg("unexpectedStatementTransactionsPagination"));
	}
	return {
		rows: rows as StatementTransaction[],
		pagination: pagination ? {
			total: Number(pagination.total),
			page: Number(pagination.page),
			perPage: Number(pagination.perPage),
			totalPages: Math.ceil(Number(pagination.total) / Number(pagination.perPage)),
		} : null,
	};
};
